<section class="rs-content-wrapper rs-header-has-level2">
  <main id="maincontent" role="main">
    <div class="rs-fe3"></div>
    <div class="row">
      <div class="columns small-12">
        <div class="rs-me"></div>
        <div class="rs-flex-row">
          <div class="rs-flex-columns small-12 medium-4 rs-order-m2">
            <img
              alt=""
              src="{{ 'flexEmergency.entry.imageLink' | translate }}"
              data-src="{{ 'flexEmergency.entry.imageLink' | translate }}"
            />
          </div>
          <div class="rs-flex-columns small-12 medium-8 rs-order-m1">
            <div class="rs-flex-row rs-flex-collapse rs-flex-middle">
              <div class="rs-flex-column rs-flex-shrink">
                <img
                  alt=""
                  class="rs-margin-right1"
                  src="{{ 'flexEmergency.entry.flexSVG' | translate }}"
                  data-src="{{ 'flexEmergency.entry.flexSVG' | translate }}"
                />
              </div>
              <div class="rs-flex-column">
                <h1 class="rs-tit4 rs-no-padding-bottom">
                  {{ 'flexEmergency.entry.title' | translate }}
                </h1>
                <p class="rs-txt-details">{{ 'flexEmergency.entry.subtitle' | translate }}</p>
              </div>
            </div>
            <p [innerHTML]="'flexEmergency.entry.htmlContent' | translate: true"></p>
            <button
              class="rs-btn"
              (click)="goToStep2()"
              data-tms-event="button-click"
              data-tms-button-zone="flex-emergency-entry"
              data-tms-button-name="continue"
            >
              {{ 'flexEmergency.entry.continue' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="rs-le2"></div>
  </main>
</section>
